import React, { Component } from 'react'
import classnames from 'classnames'
import { image } from 'services'
import Link from 'next/link'
import { advantage } from './styles'

class Advantage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hover: false,
      currentIcon: null
    }
  }
  activeItem = item => {
    return item.url === this.props.pathname ? 'active' : ''
  }
  getIcon = item => {
    const isActive = this.activeItem(item) === 'active'
    const {
      hover,
      currentIcon
    } = this.state
    if (isActive) {
      return item.icon.replace('.svg', '-white.svg')
    }
    if (hover && item.icon === currentIcon) {
      return item.icon.replace('.svg', '-white.svg')
    }
    return item.icon;
  }
  render() {
    const advantageList = [
      {
        title: 'Capta más propiedades',
        icon: '/advantage/icono-captar.svg',
        url: '/acquire-more-properties',
        asUrl: '/capta-propiedades'
      },
      {
        title: 'Genera más contactos',
        icon: '/advantage/icono-promover.svg',
        url: '/better-serve-your-clients',
        asUrl: '/ayuda-tus-clientes',
      },
      {
        title: 'Desarrolla relaciones sólidas con tus clientes',
        icon: '/advantage/icono-crm.svg',
        url: '/transaction-management',
        asUrl: '/gestion-transaccion',
      },
      {
        title: 'Conviértete en un experto inmobiliario en tu zona',
        icon: '/advantage/icono-capacitacion.svg',
        url: '/personal-development',
        asUrl: '/desarrollo-personal',
      },
      {
        title: 'Soporte por nuestros expertos legales y fiscales',
        icon: '/advantage/icono-soporte.svg',
        url: '/administrative-support',
        asUrl: '/soporte-administrativo',
      },
      {
        title: 'Comisiones justas',
        icon: '/advantage/icono-100-comision.svg',
        url: '/promote-your-properties',
        asUrl: '/promueve-propiedades',
      }
    ]
    return (
      <div className="container-advantage">
        {advantageList.map((item, index) => (
          <div
            className={classnames('advantage', this.activeItem(item))}
            key={index}
            onMouseEnter={() => this.setState({ hover: true, currentIcon: item.icon })}
            onMouseLeave={() => this.setState({ hover: false, currentIcon: null })}
          >
            <Link href={item.url} as={item.asUrl}>
              <a className="advantage-link">
                <img src={image(this.getIcon(item))} />
                <span className="advantage-description">{item.title}</span>
              </a>
            </Link>
          </div>
        ))}
        <style jsx>{advantage}</style>
      </div>
    )
  }
}

export default Advantage
